import api from './api';

const assetDisposalService = {
  // Get all disposals
  getAllDisposals: async (params = {}) => {
    try {
      const response = await api.get('/asset-disposals', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching asset disposals:', error);
      throw error;
    }
  },

  // Get disposal by ID
  getDisposalById: async (id) => {
    try {
      const response = await api.get(`/asset-disposals/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching asset disposal:', error);
      throw error;
    }
  },

  // Create disposal
  createDisposal: async (data) => {
    try {
      const response = await api.post('/asset-disposals', data);
      return response.data;
    } catch (error) {
      console.error('Error creating asset disposal:', error);
      throw error;
    }
  },

  // Update disposal
  updateDisposal: async (id, data) => {
    try {
      const response = await api.put(`/asset-disposals/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating asset disposal:', error);
      throw error;
    }
  },

  // Delete disposal
  deleteDisposal: async (id) => {
    try {
      const response = await api.delete(`/asset-disposals/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting asset disposal:', error);
      throw error;
    }
  },

  // Get disposal statistics
  getDisposalStats: async () => {
    try {
      const response = await api.get('/asset-disposals/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching asset disposal statistics:', error);
      throw error;
    }
  },

  // Get next disposal code
  getNextDisposalCode: async () => {
    try {
      const response = await api.get('/asset-disposals/next-code');
      return response.data;
    } catch (error) {
      console.error('Error fetching next disposal code:', error);
      throw error;
    }
  }
};

export default assetDisposalService;
